import { getIssuePriority } from 'shared/constants/issues';
import {
  EmergencyColumn,
  CaseIdColumn,
  OrderTimeColumn,
  CompleteTimeColumn,
  WageColumn,
  FlagColumn,
  ViewColumn,
} from 'views/Wages/commonColumns';

export const getKenshinTableData = (myWageData, selectedOrganizationId) => {
  const myWage = myWageData.filter(
    (item) => item.orgId === selectedOrganizationId
  );

  const tableData = myWage.map((wage) => {
    const {
      id,
      createdAt,
      issueId,
      caseId,
      caseIdentifierId,
      casePriority,
      caseCreatedAt,
      originalWage,
      currentWage,
      starred,
    } = wage;

    return {
      caseId: caseIdentifierId,
      emergency: getIssuePriority(casePriority),
      orderTime: caseCreatedAt,
      completeTime: createdAt,
      wage: {
        originalWage: originalWage,
        currentWage: currentWage,
      },
      view: {
        wageId: id,
        issueId: issueId,
        caseId: caseId,
      },
      flag: starred,
    };
  });

  return tableData;
};

export const getKenshinTableColumns = (goToIssueDetails) => {
  return [
    CaseIdColumn(),
    EmergencyColumn(),
    OrderTimeColumn(),
    CompleteTimeColumn(),
    WageColumn(),
    ViewColumn(goToIssueDetails),
    FlagColumn(),
  ];
};
